module.exports = __webpack_public_path__ + "static/media/aisoft-badge.8eac1224.png";